export enum InputType {
  TEXT = 'text',
  EMAIL = 'email',
  PASSWORD = 'password',
  HIDDEN = 'hidden',
  NUMBER = 'number',
  TEL = 'tel',
}
